// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__x6-nH","paramInput":"JobSimulator_paramInput__2eNx8","input":"JobSimulator_input__2q845"};